export enum HipaaConsentStatus {
  Pending = 'Pending',
  Granted = 'Granted',
  Declined = 'Declined',
}
